import { useEffect } from 'react'

/**
 * Stop the page scrolling behind a modal or drawer.
 *
 * The scrollbar is replaced with equivalent padding, otherwise the whole layout
 * shifts sideways by ~10px when the overlay opens and back when it closes.
 */
export function useLockBodyScroll(locked: boolean) {
  useEffect(() => {
    if (!locked) return
    const { overflow, paddingRight } = document.body.style
    const gap = window.innerWidth - document.documentElement.clientWidth
    document.body.style.overflow = 'hidden'
    if (gap > 0) document.body.style.paddingRight = `${gap}px`
    return () => {
      document.body.style.overflow = overflow
      document.body.style.paddingRight = paddingRight
    }
  }, [locked])
}
